import { ApiConnectionFirmUsersGrid } from './apiConnectionFirmUsersGrid';

export interface IApiConnectionFirmUsersGridOwnProps {
    apiConnectionFirmId: string;
}

export type IApiConnectionFirmUsersGridProps = IApiConnectionFirmUsersGridOwnProps;

export default ApiConnectionFirmUsersGrid;